import { useNavigate } from "react-router-dom";
import PublicNav from "@/components/PublicNav";
import { Activity, Calendar, HeartPulse, MessageCircle, Trophy, Snowflake, BarChart3, Brain } from "lucide-react";

const FEATURES = [
  { icon: BarChart3, title: "Performance Dashboard", body: "Weekly, monthly and yearly mileage, recovery readiness, consistency streak and a live countdown to your next race — all on one elite console." },
  { icon: Calendar, title: "Smart Training Plan", body: "Weekly board + monthly calendar. Modular sessions you can actually follow." },
  { icon: HeartPulse, title: "Recovery", body: "Sleep, HRV, soreness, resting HR, hydration — log what makes you faster and see your readiness score every morning." },
  { icon: MessageCircle, title: "Coach Messaging + AI", body: "Direct chat with Coach JP. AI assistant for instant pacing & recovery advice." },
  { icon: Trophy, title: "Challenges & Community", body: "Leaderboards, monthly 100K club, virtual races. Accountability without ego." },
  { icon: Snowflake, title: "Cryo & Cold Exposure", body: "The signature recovery system most apps ignore." },
  { icon: Brain, title: "Nervous System Tuning", body: "Breathwork and parasympathetic protocols built into your weeks." },
  { icon: Activity, title: "AI Adaptation (Soon)", body: "Plan auto-adapts to sleep, HRV, missed sessions and fatigue trends." },
];

export default function Features() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-[#070707] text-white" data-testid="features-page">
      <PublicNav />
      <div className="max-w-6xl mx-auto px-6 sm:px-10 py-12 sm:py-20">
        <div className="font-mono-jp text-xs tracking-[0.3em] uppercase text-[#d7ff00]">STEP 02 · WHAT'S INSIDE</div>
        <h1 className="mt-3 font-display text-5xl sm:text-7xl uppercase leading-[0.9]">More than a <span className="text-[#d7ff00]">running app</span></h1>
        <p className="mt-4 text-[#bbb] max-w-xl">An elite coaching ecosystem combining endurance training, recovery science, and human coaching.</p>

        <div className="mt-12 grid gap-px bg-[#1f1f1f] sm:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map(f => {
            const Icon = f.icon;
            return (
              <div key={f.title} className="bg-[#0a0a0a] p-6 group hover:bg-[#111]" data-testid={`feature-${f.title.toLowerCase().replace(/\s+/g,"-")}`}>
                <div className="w-12 h-12 flex items-center justify-center border border-[#222] mb-4 group-hover:border-[#d7ff00] transition-colors">
                  <Icon className="w-5 h-5 text-[#d7ff00]" strokeWidth={1.5} />
                </div>
                <div className="font-display text-2xl uppercase">{f.title}</div>
                <p className="mt-2 text-[#bbb] text-sm leading-relaxed">{f.body}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-12">
          <button onClick={() => nav("/pricing")} className="bg-[#d7ff00] text-black font-display tracking-wider uppercase text-xl px-10 py-4 hover:bg-white active:scale-[0.98]" data-testid="features-continue">
            See Packages
          </button>
        </div>
      </div>
    </div>
  );
}
